// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24pPQ","input":"styles_input__3s6-A"};